import { registerBlockType } from '@wordpress/blocks';

/**
 * Internal dependencies
 */
import Edit from './edit';
import Save from './save';
import metadata from './block.json';
import attributes from './attributes';
import icon from './boxmemberIcon.svg';

/**
 * BOX SLOGAN MEMBER
 */
registerBlockType( metadata.name, {
	attributes,
	edit: Edit,
	save: Save,
	icon: (
		<img src={ icon } alt="Box Slogan Member" height={ 16 } width={ 16 } />
	),
} );
